<div class="chart-card p-4 white-bg">
    <ng-container *ngIf="isProgress">
        <mat-spinner class="spinner" diameter="20"></mat-spinner>
    </ng-container>
    <ng-container *ngIf="!isProgress">
        <div class="chart-header" [ngClass]="errorhandledashboardwidget.status ? 'hide' : ''">
            <div class="title">
                <h3 class=" primary-text lighter-text">{{ title }}</h3>
                <p class="content-s subtitle lighter-text primary-text">{{ subtitle }}</p>
            </div>
            <div class="options-icon">
                <!-- <p
          #origin
          *ngIf="mode === 'preview'"
          class="content-m primary-text"
          (click)="openCharttype(origin)"
        >
          Change chart
        </p> -->

                <img src="assets/widgets/changeChart.svg" [ngClass]="!handledashboardwidgetnodata.status && !errorhandledashboardwidget.status ? '' : 'hide'" class="icon-s" tooltip="Change chart" #origin *ngIf="mode === 'preview'" (click)="openCharttype(origin)">

                <img #moreOptionOrigin *ngIf="mode === 'builder'" src="assets/widgets/more-options.svg" class=" more-options icon-s" (click)="
            openOverlay_moreoptions_click(moreOptionRef, moreOptionOrigin)
          " />
            </div>
        </div>
        <div class="chart-body">
            <div [hidden]="handledashboardwidgetnodata.status || errorhandledashboardwidget.status || isProgress" #chartContainer class="echarts-container" [id]="'chart' + widgetId"></div>
            <ng-container *ngIf="handledashboardwidgetnodata.status || errorhandledashboardwidget.status">
                <div class="dashboardwidget-nodata">
                    <div class="nodata-img">
                        <!-- <img src="assets/widgets/empty-data.svg" /> -->
                        <img [src]="widgetBuilderVarService?.selectedChart?.icon ? widgetBuilderVarService?.selectedChart?.icon : 'assets/widgets/empty-data.svg'" />
                    </div>
                    <div>
                        <p class="m-0 content-m secondary-text no-result">{{handledashboardwidgetnodata.status ? handledashboardwidgetnodata.errmsg:errorhandledashboardwidget.errmsg}}
                        </p>
                    </div>
                </div>
            </ng-container>
        </div>
    </ng-container>
</div>

<ng-container (click)="$event.stopPropagation()">
    <ng-template #moreOptionRef>
        <!-- *ngIf="moreOptionState" (click)="$event.stopPropagation()" -->
        <div class="more-option radius-s" #filterOrigin>
            <div class="more-option-container radius-s primary-bg py-2 tooltip-shadow px-3">
                <div class="icon-div" (click)="refreshWidget()">
                    <img src="assets/widgets/refresh.svg" class="enable-action" tooltip="Refresh" class="tooltip-enable" style="cursor: pointer" />
                </div>
                <div class="vertical-line border-light-left"></div>
                <div class="icon-div" (click)="download_click()">
                    <img src="assets/widgets/download.svg" [ngClass]="
              handledashboardwidgetnodata.status
                ? 'disable-action'
                : 'enable-action'
            " [tooltip]="'Download'" class="tooltip-enable" />

                    <div class="vertical-line border-light-left"></div>
                </div>
                <div class="vertical-line border-light-left"></div>
                <div class="icon-div" (click)="
            openOverlay_templateRef(dateFilterRef, filterOrigin, 'datefilter')
          ">
                    <img src="assets/widgets/filter.svg" [tooltip]="'Filter'" class="enable-action tooltip-enable" />
                    <!-- <img  style="cursor:default;opacity: 32%" src="assets/widgets/filter.svg" [tooltip]="moreoptiontitles[3]" 
                    class="disable-action tooltip-enable">  -->
                    <div class="vertical-line border-light-left"></div>
                </div>
                <div class="vertical-line border-light-left"></div>
                <div class="icon-div" (click)="
            fullscreen_click(headerContent, subheaderContent, bodyContent)
          " [tooltip]="'Maximize'" class="enable-action tooltip-enable">
                    <!-- #fullscreenOrigin -->
                    <img src="assets/widgets/full-screen.svg" />

                    <!-- [ngClass]="handledashboardwidgetnodata.status ? 'disable-action':'enable-action'"
                    [tooltip]="'Fill screen'" class="tooltip-enable">  nodatavariable -->

                    <!-- ,fullscreenOrigin -->
                    <!-- <ng-container *ngIf="widgetType=='Chart'"> -->
                    <!-- <div class="vertical-line border-light-left"></div> -->
                </div>
                <div class="vertical-line border-light-left"></div>
                <div class="icon-div" #colorPalateOrigin (click)="
            openOverlay_templateRef(
              colorPalateRef,
              colorPalateOrigin,
              'colorpalate'
            )
          ">
                    <img *ngIf="widgetInfo.type != 'label' && widgetInfo.type != 'table'" src="assets/widgets/edit-color.svg" [tooltip]="'Color'" class="tooltip-enable" [ngClass]="
              handledashboardwidgetnodata.status
                ? 'disable-action'
                : 'enable-action'
            " />
                    <!-- color palatte option is disabled for Table -->
                    <img *ngIf="widgetInfo.type == 'table' || widgetInfo.type == 'label'" style="cursor: default; opacity: 32%" src="assets/widgets/edit-color-disable.svg" class="tooltip-enable" />
                </div>
            </div>
            <div class="arrow-div m-0">
                <!-- <div class="arrow">

            </div> -->
                <img src="assets/widgets/play-gray.svg" />
            </div>
            <div class="close-option">
                <button class="icon-button p-3 tooltip-enable primary-bg radius-s tooltip-shadow" (click)="closeOptions_click()">
          x
          <!-- <img class="exit-option" src="assets/widgets/close-more-options.svg" class="enable-action"
            (click)="closeOptions_click()"> -->
          <!-- <img class="exit-option" src="assets/widgets/window-close-line.svg"
                    class="enable-action" (click)="closeOptions_click()"> -->
        </button>
            </div>
        </div>
    </ng-template>

    <ng-template #dateFilterRef>
        <div class="more-option-filter-container border-light primary-bg radius-m lighter-text dropdown-shadow">
            <div class="more-option-filter">
                <div class="filter-header-wrapper radius-m primary-bg pt-6 px-6">
                    <ul id="dateFilter" class="span-m primary-text m-0 p-0">
                        <ng-container *ngFor="
                let filter of dashboardBuilderVarService.relativeTimeMetadata;
                let i = index
              ">
                            <li class="li-m" (click)="
                  relativeTimeClick('dateFilter', filter.value, 'relativetime')
                ">
                                {{ filter.disp }}
                            </li>
                        </ng-container>
                    </ul>
                    <!-- <hr class="horizondal-seperator border-light-bottom"> -->
                </div>
                <div class="seperator border-light-bottom radius-m mx-6"></div>
                <div class="filter-body-wrapper pb-6 px-6 radius-m">
                    <form [formGroup]="selectTime">
                        <div class="filter-body-row-1">
                            <p class="primary-text content-l">From</p>
                            <!-- <input type="date" id="start" [value]="fromDate | date : 'yyyy-MM-dd'"
                            (input)="fromDate = $event.target.value"
                            (change)="load_widgetData('dateFilter')"> -->

                            <!-- <input class="primary-bg input-m primary-text input-border tooltip-enable border-none" type="date" id="to" formControlName="fromDate" [min]="mindate"
                            [max]="maxdate"
                            tooltip="{{selectTime.controls.toDate.value | date:'dd MMM yy HH:mm'}}" style="cursor:pointer;"> -->
                            <input class="primary-bg input-border input-m primary-text tooltip-enable border-none" type="date" id="to" formControlName="fromDate" [max]="maxdate" tooltip="{{
                  selectTime.controls.toDate.value | date : 'dd MMM yy'
                }}" style="cursor: pointer" />
                        </div>
                        <div class="filter-body-row-2">
                            <p class="primary-text content-l">To</p>
                            <!-- <input type="date" id="end" [value]="toDate | date : 'yyyy-MM-dd'"
                            (input)="toDate = $event.target.value"
                            (change)="load_widgetData('dateFilter')"> -->
                            <input class="primary-bg input-border input-m primary-text tooltip-enable border-none" type="date" id="from" formControlName="toDate" [max]="maxdate" tooltip="{{
                  selectTime.controls.toDate.value | date : 'dd MMM yy'
                }}" style="cursor: pointer" />
                        </div>
                        <button class="apply submit" (click)="dateFilterClick()">
              Apply
            </button>
                        <span class="date-validation alert-text span-s" *ngIf="selectTime.errors">
              {{
                sharedService.metaData.rule.lookbackmeta.formerrormsg
                  .invalidtime
              }}
            </span>
                    </form>
                </div>
            </div>
        </div>
    </ng-template>

    <ng-template #colorPalateRef>
        <div class="edit_color_palet primary-bg radius-m module-chip-shadow">
            <div class="color-container primary-bg p-5 radius-s">
                <!-- #selectedColor -->
                <ng-container *ngFor="
            let colors of widgetBuilderVarService.colorPalette;
            let i = index
          ">
                    <div>
                        <div class="color-1 p-1" [ngClass]="
                i == selectedColorIndex ? 'color-planel-highlight' : ''
              " (click)="colorPalatte_click(i,colors)">
                            <!--  id="selectColor{{i}}" -->
                            <ng-container *ngFor="let color of colors">
                                <!-- <input type=color [value]="color" (click)="$e  vent.stopImmediatePropagation()"> -->
                                <span class="pix" [ngStyle]="{ 'background-color': color }"></span>
                                <!-- (colorEvent)="valuePasstochild($event)" -->
                            </ng-container>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
    </ng-template>
</ng-container>

<ng-template #headerContent>{{ title }}</ng-template>
<ng-template #subheaderContent>{{ subtitle }}</ng-template>
<ng-template #bodyContent>
    <div class="chart-body">
        <div [hidden]="isObjectEmpty(chartData)" width="100%" class="echarts-container" echarts [id]="'fullscreen' + widgetId" [options]="chartOptions"></div>
        <ng-container *ngIf="isObjectEmpty(chartData)">
            <div class="dashboardwidget-nodata">
                <div class="nodata-img">
                    <img src="assets/widgets/empty-data.svg" />
                </div>
                <div>
                    <p class="m-0 content-m secondary-text no-result">No result</p>
                </div>
            </div>
        </ng-container>
    </div>
</ng-template>